<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-21 14:36:31
 * @LastEditTime: 2022-10-25 17:36:19
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/index.vue
 *
-->
<template>
  <div class="powdered_Milk_Index">
    <keep-alive :include="includes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<style lang="less" scoped>
.powdered_Milk_Index {
  width: 100%;
  min-height: 100%;
  background-color: #E5E2E2;
}
</style>

<script>
import Vue from 'vue';
import {mapState} from "vuex";
import {getCookie, getUrlParamsByName, is_weixin, isUserLogin, setCookie} from "@/assets/js/common.js";

var hasHandlerInfo = false; // 是否初始化用户信息
export default {
  name: "powderedMilk",
  components: {},
  data() {
    return {
      isRecommendSwitch: null,    // 是否开启了智能推荐
      UserInfo: {},   // 用户信息
      babyInfo: [],
      optionList: []
    };
  },

  computed: {
    // 在computed中动态监控
    ...mapState({
      includes: (state) => state.includes,
    }),
    babyNums() {
      return localStorage.getItem('babyNums')
    }
  },
  beforeRouteEnter(to, from, next) {
    // 如果是定制页返回，清空缓存的宝宝月龄信息
    if (getUrlParamsByName('fromLoginEdit')) {
      localStorage.removeItem("babyTimes")
    }
    // 注册页面回来，直接加载页面即可，不需要再去获取用户信息
    if (getUrlParamsByName("fromLogin") || getCookie('fromPath') != null) {
      next()
    } else {
      let curVM = Vue.prototype;
      if (is_weixin()) {
        // 微信环境
        if (getCookie("xmh_openid") == null || getCookie("xmh_openid") == "") {
          //判断有没有openId
          location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
        } else {
          let UserInfo = JSON.parse(localStorage.getItem("userInfo"));
          if (UserInfo == null || UserInfo == "" || UserInfo.mobile == null || UserInfo.mobile == "" || UserInfo.mobile == "null") {
            //   // 没有用户信息
            curVM.wxJsSet.getUserInfoBywx(
                curVM,
                function () {
                  let UserInfo = JSON.parse(localStorage.getItem("userInfo"));
                  if (UserInfo && UserInfo.mobile != null && UserInfo.mobile != "" && UserInfo.mobile != "null") {
                    sensors.login(UserInfo.crm_id)
                    curVM.wxJsSet.getBabyInfoBywx(curVM, next);
                    hasHandlerInfo = true;
                  } else {
                    sensors.login(getCookie("xmh_unionid"));
                    next()
                  }
                },
                function () {
                  sensors.login(getCookie("xmh_unionid"));
                  next()
                }
            );
          } else {
            // 有用户信息
            sensors.login(UserInfo.crm_id)
            curVM.wxJsSet.getBabyInfoBywx(curVM, next);
            hasHandlerInfo = true;
          }
        }
      } else {
        // 非微信环境
        let UserInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (getCookie("xmh_phone") == null || getCookie("xmh_phone") == "") {
          next()
        } else {
          if (UserInfo && UserInfo.mobile != null && UserInfo.mobile != "" && UserInfo.mobile != "null") {
            curVM.wxJsSet.getBabyInfoBywx(curVM, next);
            hasHandlerInfo = true
          } else {
            next()
          }
        }
      }
    }
  },
  mounted() {
    this.$store.commit("changeIncludes", ["powderedMilk", "powderedMilkList"]);
    // 已登录
    if (!isUserLogin()) {
      this.handlerInfo()
    }
  },
  created() {
    this.getMonthsPeriod()
    this.babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
    this.UserInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    // 判断宝宝状态
    handlerInfo() {
      if (this.babyInfo && this.babyInfo.length != 0) {
        localStorage.setItem("babyNum", this.babyInfo.length); // 存入宝宝的个数
        localStorage.setItem("handleTagBY", "1");

        var babynumBir1 = this.babyInfo.find(item => item.num == '1') && this.babyInfo.find(item => item.num == '1').birth || '';
        var babynumBir2 = this.babyInfo.find(item => item.num == '2') && this.babyInfo.find(item => item.num == '2').birth || '';
        // 判断第几胎月龄最小
        if (getCookie("babyNum")) {
          this.babyCurrentNum = getCookie("babyNum"); // 从cookie中获取切换宝宝的胎次
          this.babyCurrentNum = parseInt(this.babyCurrentNum);
        } else {
          if (!!babynumBir1 && !!babynumBir2) {
            // 判断两胎是否都有生日
            // 判断第几胎月龄小
            new Date(babynumBir1).getTime() < new Date(babynumBir2).getTime() ? (this.babyCurrentNum = 2) : (this.babyCurrentNum = 1);
          } else {
            babynumBir1 && !babynumBir2 ? (this.babyCurrentNum = 1) : babynumBir2 ? (this.babyCurrentNum = 2) : (this.babyCurrentNum = 1);
          }
          setCookie("babyNum", this.babyCurrentNum, 30);
          localStorage.setItem("babyNums", this.babyCurrentNum);
        }
      } else {
        localStorage.setItem("babyNum", 0);
      }
    },
    // 获取月龄段
    getMonthsPeriod() {
      this.$http.get("/babyWikiRevision/monthsPeriod", {}, res => {
        if (res.code === "200") {
          this.optionList = [{name: "全部", id: 0}];
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].id > 0 && res.data[i].id < 7) {
              this.optionList.push(res.data[i]);
            }
          }
          const babyNum = localStorage.getItem('babyNums')
          const babyInfo = JSON.parse(localStorage.getItem('babyInfo'))
          let id = babyInfo && babyInfo.length ? babyInfo.filter(item => item.num == babyNum)[0].tag_id : null
          if (id == 1) {
            id = 2
          } else if (id == 2) {
            id = 1
          }
          const data = this.optionList.filter(item => item.id == id)[0]
          localStorage.setItem("babyBuried", JSON.stringify(data ? data : null))
        }
      });
    },
  },

  watch: {
    babyNums: {
      handler(newValue) {
        alert(newValue)
      },
      deep: true
    }
  }
};
</script>
